import React, { Component } from "react";
import "./App.css";
import { AuthRouter, AppRouter } from "./routers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

class App extends Component {
  render() {
    return (
      <div className="App">
        <ToastContainer position="bottom-center" autoClose={false} />
        {localStorage.getItem("access_token") != null ? (
          <AppRouter />
        ) : (
          <AuthRouter />
        )}
      </div>
    );
  }
}

export default App;
